<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 98%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.auName" style="width: 130px;" size="mini" placeholder="名称"
                        clearable></el-input>
                        <el-input v-model="formDatas.amcDes" style="width: 130px;" size="mini" placeholder="备注"
                        clearable></el-input>
                         <el-date-picker v-model="formDatas.auDateEntryStart" type="date"
                                        value-format="yyyy-MM-dd" placeholder="入职开始日期" style="width: 140px;" size="mini">
                                    </el-date-picker>
                                    <span style="margin: 0 10px;">-</span>
                                    <el-date-picker v-model="formDatas.auDateEntryEnd" type="date"
                                        value-format="yyyy-MM-dd" placeholder="入职结束日期" style="width: 140px;" size="mini">
                                    </el-date-picker>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="SerchMore"
                        style="margin-left: 10px">更多</el-button>
                    <el-dropdown size="mini" split-button type="warning" style="margin-left: 10px;" :split-button="true"
                        @click="Out()" @command="Out">
                        导出全部
                        <el-dropdown-menu slot="dropdown">
                            <!-- <el-dropdown-item style="background-color: #E6A23C;color: white;margin: 5px 0;"
                                command="1">导出全部</el-dropdown-item> -->
                            <el-dropdown-item style="background-color: #E6A23C;color: white;margin: 5px 0;"
                                command="2">导出使用记录</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>

                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption" row-key-field-name="keyindex"
                        :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
                        :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 详情 -->
            <el-dialog title="详情" :visible.sync="IsDetail" width="70%" top="8vh">
                <div style="max-height: 500px; overflow-y: scroll">
                    <el-descriptions :column="3" border :labelStyle="{
                        color: '#409EFF',
                        textAlign: 'center',
                        width: '14%',
                        fontSize: '12px'
                    }" :contentStyle="{
    textAlign: 'center',
    width: '18%',
    fontSize: '12px'
}">
                        <el-descriptions-item label="姓名">{{ DetailArr.auName }}</el-descriptions-item>
                        <el-descriptions-item label="归属">{{ DetailArr.auBelong }}</el-descriptions-item>
                        <el-descriptions-item label="所在部门">{{ DetailArr.auDepartment }}</el-descriptions-item>
                        <el-descriptions-item label="职务">{{ DetailArr.auPost }}</el-descriptions-item>
                        <el-descriptions-item label="性别">{{ DetailArr.auSex }}</el-descriptions-item>
                        <el-descriptions-item label="年龄">{{ DetailArr.auAge }}</el-descriptions-item>
                        <el-descriptions-item label="入职时间">{{ DetailArr.auDateEntry }}</el-descriptions-item>
                        <el-descriptions-item label="试用期">{{ DetailArr.auProbationPeriod }}</el-descriptions-item>
                        <el-descriptions-item label="转正时间">{{ DetailArr.auDateRegular }}</el-descriptions-item>
                        <el-descriptions-item label="转岗时间">{{ DetailArr.auDateTransfer }}</el-descriptions-item>
                        <el-descriptions-item label="状态">{{ DetailArr.auStatus }}</el-descriptions-item>
                        <el-descriptions-item label="面试官">{{ DetailArr.auInterviewer }}</el-descriptions-item>
                        <el-descriptions-item label="合同到期时间">{{ DetailArr.auDateExpirationContract }}</el-descriptions-item>
                        <el-descriptions-item label="籍贯">{{ DetailArr.auOrigin }}</el-descriptions-item>
                        <el-descriptions-item label="政治面貌">{{ DetailArr.auPolitical }}</el-descriptions-item>
                        <el-descriptions-item label="户口所在地">{{ DetailArr.auAddressRegistered }}</el-descriptions-item>
                        <el-descriptions-item label="户口性质">{{ DetailArr.auAddressRegisteredType }}</el-descriptions-item>
                        <el-descriptions-item label="民族">{{ DetailArr.auNation }}</el-descriptions-item>
                        <el-descriptions-item label="婚姻状态">{{ DetailArr.auMarital }}</el-descriptions-item>
                        <el-descriptions-item label="出生年月">{{ DetailArr.auBirth }}</el-descriptions-item>
                        <el-descriptions-item label="身份证号码">{{ DetailArr.auIdcard }}</el-descriptions-item>
                        <el-descriptions-item label="身份证正面(人像面)">
                            <el-image ref="scrImg" id="scrimg" :src="DetailArr.auIdcardUp" alt="" fit="cover"
                                style="height: 50px;" :preview-src-list="[DetailArr.auIdcardUp]"></el-image>
                        </el-descriptions-item>
                        <el-descriptions-item label="身份证反面(国徽面)">
                            <el-image ref="scrImg" id="scrimg" :src="DetailArr.auIdcardDown" alt="" fit="cover"
                                style="height: 50px;" :preview-src-list="[DetailArr.auIdcardDown]"></el-image>
                        </el-descriptions-item>
                        <el-descriptions-item label="发证机关">{{ DetailArr.auIdcardIssuingAuthority
                        }}</el-descriptions-item><el-descriptions-item label="姓名">{{ DetailArr.auName
}}</el-descriptions-item>
                        <el-descriptions-item label="身份证完整地址">{{ DetailArr.auIdcardAddress }}</el-descriptions-item>
                        <el-descriptions-item label="身份证有效期">{{ DetailArr.auIdcardExpiration }}</el-descriptions-item>
                        <el-descriptions-item label="毕业院校">{{ DetailArr.auSchool }}</el-descriptions-item>
                        <el-descriptions-item label="专业">{{ DetailArr.auMajor }}</el-descriptions-item>
                        <el-descriptions-item label="学历">{{ DetailArr.auEducationLevel }}</el-descriptions-item>
                        <el-descriptions-item label="毕业时间">{{ DetailArr.auGraduationTime }}</el-descriptions-item>
                        <el-descriptions-item label="学历证书(图片)">
                            <el-image ref="scrImg" id="scrimg" :src="DetailArr.auCertificateEducation" alt="" fit="cover"
                                style="width: 100%;height: 50px;"
                                :preview-src-list="[DetailArr.auCertificateEducation]"></el-image>
                        </el-descriptions-item>
                        <el-descriptions-item label="学历证书查验证明(图片)"><el-image ref="scrImg" id="scrimg"
                                :src="DetailArr.auCertificateEducationCheck" alt="" fit="cover"
                                style="width: 100%;height: 50px;"
                                :preview-src-list="[DetailArr.auCertificateEducationCheck]"></el-image></el-descriptions-item>
                        <el-descriptions-item label="最高学历">{{ DetailArr.auEducationLevelMax }}</el-descriptions-item>
                        <el-descriptions-item label="浦发银行卡号">{{ DetailArr.auBankCardPf }}</el-descriptions-item>
                        <el-descriptions-item label="其他银行">{{ DetailArr.auBankCardOther }}</el-descriptions-item>
                        <el-descriptions-item label="其他银行卡号">{{ DetailArr.auBankCardOtherNum }}</el-descriptions-item>
                        <el-descriptions-item label="其他银行开户行">{{ DetailArr.auBankCardOtherOpen }}</el-descriptions-item>
                        <el-descriptions-item label="本人联系方式">{{ DetailArr.auContactMine }}</el-descriptions-item>
                        <el-descriptions-item label="个人邮箱">{{ DetailArr.auEmail }}</el-descriptions-item>
                        <el-descriptions-item label="父亲姓名">{{ DetailArr.auContactDad }}</el-descriptions-item>
                        <el-descriptions-item label="父亲工作单位">{{ DetailArr.auContactDadUnit }}</el-descriptions-item>
                        <el-descriptions-item label="父亲联系方式">{{ DetailArr.auContactDadPhone }}</el-descriptions-item>
                        <el-descriptions-item label="母亲姓名">{{ DetailArr.auContactMom }}</el-descriptions-item>
                        <el-descriptions-item label="母亲工作单位">{{ DetailArr.auContactMomUnit }}</el-descriptions-item>
                        <el-descriptions-item label="母亲联系方式">{{ DetailArr.auContactMomPhone }}</el-descriptions-item>
                        <el-descriptions-item label="兄弟姐妹姓名">{{ DetailArr.auContactSibling }}</el-descriptions-item>
                        <el-descriptions-item label="兄弟姐妹工作单位">{{ DetailArr.auContactSiblingUnit }}</el-descriptions-item>
                        <el-descriptions-item label="兄弟姐妹联系方式)">{{ DetailArr.auContactSiblingPhone }}</el-descriptions-item>
                        <el-descriptions-item label="同城紧急联系人">{{ DetailArr.auContactEmergency
                        }}</el-descriptions-item><el-descriptions-item label="姓名">{{ DetailArr.auName
}}</el-descriptions-item>
                        <el-descriptions-item label="同城紧急联系人工作单位">{{ DetailArr.auContactEmergencyUnit
                        }}</el-descriptions-item>
                        <el-descriptions-item label="同城紧急联系人联系方式">{{ DetailArr.auContactEmergencyPhone
                        }}</el-descriptions-item>
                        <el-descriptions-item label="现居住地址">{{ DetailArr.auAddressNow }}</el-descriptions-item>
                        <el-descriptions-item label="社保电脑号">{{ DetailArr.auSocialSecurityNum }}</el-descriptions-item>
                        <el-descriptions-item label="公积金账号">{{ DetailArr.auProvidentFund }}</el-descriptions-item>
                        <el-descriptions-item label="社保备注">{{ DetailArr.auSocialSecurityDes }}</el-descriptions-item>
                        <el-descriptions-item label="其他信息">{{ DetailArr.auDesOther }}</el-descriptions-item>
                        <el-descriptions-item label="入职资料提交情况">{{ DetailArr.auInformationEntry }}</el-descriptions-item>
                        <el-descriptions-item label="离职原因">{{ DetailArr.auLeaveReason }}</el-descriptions-item>
                        <el-descriptions-item label="离职日期">{{ DetailArr.auLevelDate }}</el-descriptions-item>
                        <el-descriptions-item label="是否发薪">{{ DetailArr.auPayStatus }}</el-descriptions-item>
                        <el-descriptions-item label="社保备注(离职)">{{ DetailArr.auDesLeaveSocialSecurityDes
                        }}</el-descriptions-item>
                        <el-descriptions-item label="兴趣爱好和自我评价">{{ DetailArr.auEvaluateMime }}</el-descriptions-item>
                        <el-descriptions-item label="备注">{{ DetailArr.auDes }}</el-descriptions-item>

                    </el-descriptions>

                </div>
            </el-dialog>
            <!-- 筛选 -->
            <el-dialog title="更多搜索" :visible.sync="IsSerch" width="70%" top="8vh" :close-on-click-modal="false">
                <div style=" width: 94%; height: 90%;margin:1% auto;background-color: white;overflow-y: scroll;">
                    <div style="width: 100%; height: 100%; padding: 5%">
                        <el-form ref="formDatas" :model="formDatas" label-position="left" label-width="150px"
                            @submit.native.prevent>
                            <div style="width: 50%; display: inline-block">
                                <el-form-item label="所在部门">
                                    <el-input v-model="formDatas.auDepartment" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="姓名">
                                    <el-input v-model="formDatas.auName" style="width: 80%;" placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="运营商">
                                    <el-input v-model="formDatas.aocName" style="width: 80%;" placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="归属">
                                    <el-input v-model="formDatas.auBelong" style="width: 80%;" placeholder="请输入"></el-input>
                                </el-form-item>
                            </div>
                            <div style="width: 50%; display: inline-block">
                                <el-form-item label="入职时间">
                                    <el-date-picker v-model="formDatas.auDateEntryStart" type="date"
                                        value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 44%;">
                                    </el-date-picker>
                                    <span style="margin: 0 10px;">-</span>
                                    <el-date-picker v-model="formDatas.auDateEntryEnd" type="date"
                                        value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 44%;">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="个人手机号">
                                    <el-input v-model="formDatas.auContactMine" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="公司手机号">
                                    <el-input v-model="formDatas.amcNumber" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="短号">
                                    <el-input v-model="formDatas.amcNumberCornet" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>

                            </div>
                            <el-form-item>
                                <el-button type="primary" @click="partserch(), IsSerch = false"
                                    style="margin-left: 100px;">立即搜索</el-button>
                                <el-button @click="closeSizer()" style="margin-left: 200px">取消</el-button>
                            </el-form-item>
                        </el-form>

                    </div>
                </div>
            </el-dialog>
            <!-- 使用记录 -->
            <el-dialog title="使用记录" :visible.sync="workingWithRecordsShow" width="70%" top="8vh">
                <el-card style="width: 90%;margin: 20px auto;text-align: center;">
                    <div style="margin: 20px;">
                        使用月份
                    </div>
                    <div style="margin: 20px;">
                        <el-date-picker v-model="userMonth" type="month" value-format="yyyy-MM" placeholder="选择日期">
                        </el-date-picker>
                    </div>
                    <div style="margin: 20px;">
                        运营商
                    </div>
                    <div style="margin: 20px;">
                        <el-select v-model="aocName" placeholder="请选择">
                            <el-option label="联通" value="联通">
                            </el-option>
                            <el-option label="电信" value="电信">
                            </el-option>
                            <el-option label="移动" value="移动">
                            </el-option>
                        </el-select>
                    </div>
                </el-card>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="workingWithRecordsClose">取 消</el-button>
                    <el-button type="primary" @click="workingWithRecordsClick">确定</el-button>
                </div>
            </el-dialog>
            <!-- 编辑日期 -->
            <el-dialog title="编辑" :visible.sync="dbtrue" width="50%" top="8vh">
                <el-select v-model="dateUpdata" placeholder="请选择" v-if="TypeId == 2">
                    <el-option v-for="item in EditArr || []" :label="item.key" :value="item.value" :key="item.id">
                    </el-option>
                </el-select>
                <!-- <el-select  v-model="dateUpdata" placeholder="请选择" @change="$forceUpdate()">
                    <el-option v-for="item in auDepartmentArr || []" :label="item.audName" :value="item.audId"
                        :key="item.audId">
                    </el-option>
                </el-select> -->
                <el-cascader v-if="TypeId == 3" v-model="dateUpdata" :options="auDepartmentArr" :show-all-levels="false"  :props="{ checkStrictly: true }"></el-cascader>
                <div v-if="TypeId == 3">
                    <div style="margin: 15px 5px;">是否为部门长</div>
                    <el-select v-model="auPostManage" placeholder="请选择" style="margin: 15px 5px;">
                        <el-option label="是" :value="1" :key="1">
                        </el-option>
                        <el-option label="否" :value="2" :key="2">
                        </el-option>
                    </el-select>
                </div>
                <el-date-picker v-if="TypeId == 1" v-model="dateUpdata" type="date" value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                </el-date-picker>
                <span slot="footer" class="dialog-footer">
                    <!-- <el-button @click="CloseBreak">取 消</el-button> -->
                    <el-button type="primary" @click="sureDate">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>
  
<script>

import {
    getAddressBookList, updateAddressBook, getAjUserDetails, exportAddressBook, exportAddressBookRecord, getAjUserDepartmentList
} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            dateUpdata: '',
            TypeId: 0,
            auPostManage: '',
            auDepartmentArr: [],
            dbtrue: false,
            workingWithRecordsShow: false,
            userMonth: '',
            aocName: '',
            IsSerch: false,
            // 名族
            auNationArr: [],

            Related: false,
            afcTypearr: [],
            aacTypearr: [],
            aaTypearr: [],
            amTypearr: [],
            IsSerch: false,
            dialog: false,
            edit: false,
            form: {

            },
            DetailArr: [],
            IsDetail: false,
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                // {
                //     field: "",
                //     key: "checkbox",
                //     type: "checkbox",
                //     fixed: 'left',
                //     title: "",
                //     width: 50,
                //     align: "center",
                // },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    fixed: 'left',
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "auName",
                    key: "auName",
                    title: "姓名",
                    align: "center",
                    fixed: 'left',
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    
                                >
                                    {row.auName}
                                </el-button>

                            </span>
                        );
                    },
                },
                {
                    field: "auBelong",
                    key: "auBelong",
                    title: "归属",
                    width: 100,
                    align: "center",
                },
                {
                    field: "auDepartment",
                    key: "auDepartment",
                    title: "花名册部门",
                    width: 120,
                    align: "center",
                },
                {
                    field: "audName",
                    key: "audName",
                    title: "所在部门",
                    width: 100,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;;" onDblclick={() => this.getdbtrue(row.audId, 'audId', rowIndex, row.auId, 3, this.auDepartmentArr,row)}>{row.audName}</div>
                            </span>
                        );
                    },
                },
                {
                    field: "auDateEntry",
                    key: "auDateEntry",
                    title: "入职日期",
                    width: 100,
                    align: "center",
                },
                {
                    field: "auContactMine",
                    key: "auContactMine",
                    title: "个人手机号",
                    align: "center",
                    width: 100,
                    edit: true,

                },
                {
                    field: "amcNumber",
                    key: "amcNumber",
                    title: "公司手机号",
                    align: "center",
                    width: 100,
                },
                {
                    field: "amcDes",
                    key: "amcDes",
                    title: "备注",
                    align: "center",
                    width: 100,
                },
                {
                    field: "amcNumberCornet",
                    key: "amcNumberCornet",
                    title: "短号",
                    align: "center",
                    width: 100,

                },
                {
                    field: "aocName",
                    key: "aocName",
                    title: "运营商",
                    align: "center",
                    width: 100,

                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                auBelong:'',
                auDepartment: '',
                amcDes: '',
                auName: '',
                aocName: '',
                auContactMine: '',
                afOwnerType: '',
                amcNumber: '',
                amcNumberCornet: '',
                auDateEntryStart:'',
                auDateEntryEnd:'',
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;

        this.getList();
        getAjUserDepartmentList({ pageSize: 0 }).then((res) => {
            res.data.forEach((item, index) => {
                const s = {
                    value: item.audId,
                    label: item.audName,
                }
                if (item.ajUserDepartmentListChild.length > 0) {
                    s.children = []
                    item.ajUserDepartmentListChild.forEach((data, id) => {
                        const ss = {
                            value: data.audId,
                            label: data.audName,
                        }
                       
                        s.children.push(ss)
                    })
                };
                this.auDepartmentArr.push(s)
            })
        });
    },
    mounted() {

    },
    methods: {
        sureDate() {
            this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    var formdata = this.dateUpdata[0] || this.dateUpdata;
                    if(this.dateUpdata.length > 1){
                        formdata = this.dateUpdata[this.dateUpdata.length -1]
                    }
                    let formData = new FormData();
                    formData.append(this.dateKeys, formdata);
                    console.log(this.auPostManage);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.auId = this.keysId
                    jsonObj.auPostManage = this.auPostManage
                    updateAddressBook(jsonObj).then(res => {
                        if (res.status == 200) {
                          
                            this.dbtrue = false;
                            this.auPostManage = '';
                            this.getList()
                            this.$message({
                                type: "success",
                                message: "编辑成功!",
                            });
                        }

                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        getdbtrue(val, key, index, id, typeid, Arr,row) {
            console.log("双击", val, key, index);
            this.dbtrue = true;
            this.dateUpdata = val;
            this.dateKeys = key;
            this.dateIndexs = index;
            this.keysId = id;
            this.TypeId = typeid;
            this.auPostManage = row.auPostManage 
            this.EditArr = Arr

        },
        workingWithRecordsClick() {
            this.$confirm("此操作将导出该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const s = {
                        userMonth: this.userMonth,
                        aocName: this.aocName
                    }
                    this.openLoading()
                    exportAddressBookRecord(s).then(res => {
                        this.openLoading()
                        this.loadings.close()
                        window.location.href = res.data;
                        this.$message({
                            type: "success",
                            message: "导出成功!",
                        });
                        this.workingWithRecordsShow = false;
                    })
                }).catch(() => {
                    this.$message({
                        type: "success",
                        message: "已取消",
                    });
                })
        },
        workingWithRecordsClose() {
            this.workingWithRecordsShow = false;
        },
        SerchMore() {
            this.IsSerch = true;
        },
        closeSizer() {
            this.formDatas = {
                auBelong:'',
                auDepartment: '',
                auName: '',
                aocName: '',
                auContactMine: '',
                afOwnerType: '',
                amcNumber: '',
                amcNumberCornet: '',
                auDateEntryStart:'',
                auDateEntryEnd:'',
                currentPage: 1,
                pageSize: 10,
            };
            this.IsSerch = false;
            this.partserch()
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        Out(command) {
            console.log(command);
           if (!command) {
                console.log('开始导出', this.selectedRowKeysCollection)
                // this.openLoading()
                // exportAddressBook({ auIds: this.selectedRowKeysCollection.toString() }).then(res => {
                //     if (res.status == 200) {
                //         this.loadings.close()
                //         window.location.href = res.data;
                //         this.$message({
                //             type: "success",
                //             message: '导出成功',
                //         });
                //         this.checkboxOption.selectedRowKeys = this.selectedRowKeysCollection = []

                //     }
                // })
                console.log(command);
                this.openLoading()
                exportAddressBook({ exportType: 1,...this.formDatas }).then(res => {
                    if (res.status == 200) {
                        this.loadings.close()
                        window.location.href = res.data;
                        this.$message({
                            type: "success",
                            message: '导出成功',
                        });


                    }
                })
            } else if (command == '1') {
                console.log(command);
                this.openLoading()
                exportAddressBook({ exportType: 1,...this.formDatas }).then(res => {
                    if (res.status == 200) {
                        this.loadings.close()
                        window.location.href = res.data;
                        this.$message({
                            type: "success",
                            message: '导出成功',
                        });


                    }
                })
            } else if (command == '2'){
                this.userMonth = '';
                this.aocName = '';
                this.workingWithRecordsShow = true;
            }
        },

        getDetail(id) {
            getAjUserDetails({ auId: id }).then(res => {
                this.DetailArr = res.data;
                this.IsDetail = true;
                console.log(this.DetailArr);
            })
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.auId = row.auId
                    console.log(jsonObj);
                    updateAddressBook(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys() {
            console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item.auId) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item.auId);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys) {
            console.log(isSelected, selectedRowKeys);
            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item.auId) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item.auId), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected) {
            const rowKey = row.auId;

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAddressBookList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();
                // this.$message({
                //     type: "success",
                //     message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAddressBookList(this.formDatas).then((res) => {
                const resData = res.data;
                resData.forEach((item, index) => {
                    item.keyindex = index;
                })
                this.tableData = resData;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();
                // this.$message({
                //     type: "success",
                //     message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAddressBookList(this.formDatas).then((res) => {
                const resData = res.data;
                resData.forEach((item, index) => {
                    item.keyindex = index;
                })
                this.tableData = resData;
                this.totalCount = res.total;
            });
        },
    },
};
</script>
  
<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>
  